module.exports = __webpack_public_path__ + "media/components/home/users-are-saying/img/star-2af113780ccb8b214d51dbf33f307d89.svg";